module.exports = __webpack_public_path__ + "img/banner-McXup.1e82d474.jpg";